import { render } from "./UiPropCustomListProps.vue?vue&type=template&id=10b529cc"
import script from "./UiPropCustomListProps.vue?vue&type=script&lang=js"
export * from "./UiPropCustomListProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__